import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store'
import vuetify from './plugins/vuetify'
import ECharts from 'vue-echarts'
import VueTheMask from 'vue-the-mask'
import VueDragscroll  from 'vue-dragscroll'
import AsyncComputed from 'vue-async-computed'
import VCurrencyField from 'v-currency-field'
import { VTextField } from 'vuetify/lib'
import { VueMaskDirective } from 'v-mask'

const urlParams = new URLSearchParams(window.location.search);
const grupoEconomico = urlParams.get('grupoEconomico');
if (grupoEconomico && !isNaN(parseInt(grupoEconomico))) {
  sessionStorage.setItem('pending_grupoEconomico', grupoEconomico);
}

Vue.directive('mask', VueMaskDirective);
Vue.component('v-chart', ECharts)
Vue.use(VueTheMask)
Vue.use(VueDragscroll)
Vue.use(AsyncComputed)
Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, {
	locale: 'pt-BR',
	decimalLength: 2,
	autoDecimalMode: true,
	min: null,
	max: null,
	defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true
})
Vue.filter('formatPrice', function (value) {
  if(value == null || value == undefined){
    return ''
  }
  let val = (value/1).toFixed(2).replace('.', ',')
  return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
})
Vue.filter('formatDate', function (date) {
  if (!date) return null
  date = date.substr(0,10)
  const [year, month, day] = date.split("-")
  return `${day}/${month}/${year}`
})
Vue.filter('formatNullValue', function (value) {
  return value ? value : '-';
})
Vue.filter('formatDateTime', function (dateTime) {
  if (!dateTime) return null
  let date = dateTime.substr(0,10)
  let time = dateTime.substr(11,5)
  const [year, month, day] = date.split("-")

  return `${day}/${month}/${year} às ${time}h`
})

Vue.filter('formatCnpj', function (value){
  return value? value.replace(/\D/g, '').replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5") : null
})

store
  .dispatch("permissions/verifyAuth")
  .then(()=>{
    new Vue({
      router,
      store,
      vuetify,
      render: h => h(App)
    }).$mount('#app')
  })
  .catch(console.error);
